/**
 * Wrapper for the Activity Report route (/reports/activity).
 * Backward-compatible redirect into the unified admin page.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';

const ReportsActivityWrapper = () => {
    return <Navigate to="/admin?section=activity" replace />;
};

export default ReportsActivityWrapper;
